import { Fragment } from 'react';

// yoDEV: Disabled - Open in App feature removed for white-label deployment
// Always render children directly without the desktop app redirect
export const OpenInAppGuard = Fragment;
